import { render, staticRenderFns } from "./StaffDialog.vue?vue&type=template&id=578ef582&scoped=true&"
import script from "./StaffDialog.vue?vue&type=script&lang=js&"
export * from "./StaffDialog.vue?vue&type=script&lang=js&"
import style0 from "./StaffDialog.vue?vue&type=style&index=0&id=578ef582&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ef582",
  null
  
)

export default component.exports